export const theoryCards = [
  {
    name: 'Moral conviction',
    copy: 'Some attitudes are experienced as matters of fundamental right and wrong; Doubt Atlas measures the strength of that felt conviction, not the stance itself.'
  },
  {
    name: 'Metacognitive confidence',
    copy: 'Each answer asks how sure your mind feels about its own judgment, then compares that to hesitation and slider movement.'
  },
  {
    name: 'Moral uncertainty',
    copy: 'The commons maps which value conflicts produce clarity, hesitation, revision, or ambivalence across people.'
  }
];

export const valuePalette = [
  'care/harm',
  'fairness/proportionality',
  'loyalty/betrayal',
  'authority/subversion',
  'sanctity/degradation',
  'liberty/oppression',
  'honesty/deception',
  'community obligation',
  'personal autonomy',
  'truthfulness',
  'mercy'
];
